import { Http } from '../axios/interceptors'

export const getConversations = async (param) => Http('GET', `/Conversations/GetByCompany?`, param)

export const getMessages = async (param) => Http('GET', `/Conversations/GetByMessages?`, param)

export const sendMessage = async (param, body) => Http('POST', `/Conversations/SendMessages?`, param, body)

export const sendMessageImage = async (param, body) => Http('POST', `/Conversations/SendMessagesImg?`, param, body)
